<template>
  <div class="update-phone" style="height: 565px;margin-left: 20px;">
    <el-form :model="phoneForm" :rules="rules" ref="phoneForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="手机号" prop="number" style=" font-weight: bolder" class="hang">
        <el-input style="width: 60%" size="small" v-model="phoneForm.number" :maxlength="11"></el-input>
        <!-- type="number"-->
      </el-form-item>

      <el-form-item label="验证码" prop="yzmnum" style="font-weight: bolder" class="hang">
        <el-input style="width: 60%;margin-left: -80px;" size="small" v-model="phoneForm.yzmnum" :maxlength="6"></el-input>
        <!--type="number"-->
        <div class="div1">
          <span v-show="show" @click="getCode()" class="yzm" style="font-size: small">获取验证码</span>
          <span v-show="!show" class="yzm" style="margin-left: 22%">{{count}} s</span>
        </div>
      </el-form-item>
      <!--<el-form-item >-->
      <div style="margin-left: 60px; margin-bottom: 10px;">
        <nut-checkbox
          v-model="checkboxs"
          :animation="false"
          size="small">
        </nut-checkbox>
        <span @click="dialogTableVisible = true" style="position: relative ;color: firebrick">同意企业服务免责协议</span>

        <el-dialog title="同意企业服务免责协议" :visible.sync="dialogTableVisible">
          <!--<div style="height: 125%; overflow-y: scroll; margin-left: 5%;padding-right: 5%">-->
          <span style="margin-left: 5%">1.同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">4.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">5.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">6.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">7.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">8.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">9.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">10.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">11.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">12.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">13.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">14.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">15.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">16.同意企业服务免责协议</span><br/>
          <span style="margin-left: 5%">17.同意企业服务免责协议</span><br/>
          <!--</div>-->
        </el-dialog>
      </div>
      <!--</el-form-item>-->
      <el-form-item>
        <el-button type="success" size="small" @click="submitForm('phoneForm')" style=" width: 85%; margin-left: -40px;"
                   v-bind:disabled="checkboxs==false">提交
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'

  export default {
    name: "updatePhone",
    data() {
      var numCheck = (rule, value, callback) => {
        var phone = /^1[34578]\d{9}$/;
        if (!value) {
          callback(new Error('请输入手机号'));
        } else if (!phone.test(value)) {
          callback(new Error('手机号格式不对'));
        } else {
          callback();
        }
      }
      // var nameCheck = (rule, value, callback) => {
      //   var namec =  /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
      //   if (!namec.test(value)) {
      //     callback(new Error('用户名含有非法字符'))
      //   } else {
      //     callback()
      //   }
      // }
        var yzmCheck = (rule, value, callback) => {
        var yzmc = /^\d{6}$/
        if (!yzmc.test(value)) {
          callback(new Error('验证码错误'))
        } else {
          callback()
        }
      }
      return {
        nameTF: true,
        openID: this.$store.getters.getUserInfo.openID,
        // openID: '123',
        userID: this.$store.getters.getUserInfo.userID,
        // userID: 3,
        type: this.$route.query.type,
        check: 0,
        // nameCheck: this.$store.getters.getUserInfo.nameCheck,
        phoneForm: {
          name: '',
          number: '',
          yzmnum: ''
        },
        dialogTableVisible: false,
        rules: {
          // name: [
          //   {required: true, message: '请输入用户名', trigger: 'blur'},
          //   { max: 20, message: '用户名过长', trigger: 'blur'},
          //   { validator: nameCheck, trigger: 'blur'}
          // ],
          number: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {validator: numCheck, trigger: 'blur'}
          ],
          yzmnum: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
            // { max: 6, min: 6, message: '验证码错误', trigger: 'blur'},
            {validator: yzmCheck, trigger: 'blur'}
          ]
        },
        show: true,
        count: '',
        timer: null,
        checkboxs: false
      }
    },
    methods: {
      checkbox() {
        if (this.checkboxs == false) {
          this.checkboxs = true
        } else if (this.checkboxs == true) {
          this.checkboxs = false
        }
      },
      agreement() {
        this.$store.commit("setPhoneInfo", {
          "name": this.phoneForm.name,
          "phone": this.phoneForm.number,
          "yzm": this.phoneForm.yzmnum
        })
        this.$router.push({name: 'updateAgreement'})
      },
      getCode() {
        var phone = /^1[34578]\d{9}$/;
        this.$refs["phoneForm"].clearValidate();
        if (this.phoneForm.number != undefined && this.phoneForm.number != null && this.phoneForm.number != "") {
          if (phone.test(this.phoneForm.number)) {
            var num = this.check
            num++
            this.check = num
            if (num > 1) {
              Toast({
                duration: 2000,
                message: "频繁操作"
              })
              return
            }
            let params = {
              userID: this.userID,
              openID: this.openID,
              phone: this.phoneForm.number,
            }
            this.$http.getCode(params).then(response => {
              if (response.state === 1) {
                this.check = 0
                const TIME_COUNT = 60;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.show = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000)
                  Toast({
                    duration: 2000,
                    message: response.msg
                  })
                  // this.$message.success(response.msg)
                } else {
                  return false;
                }
              } else {
                this.check = 0
                Toast({
                  duration: 2000,
                  message: response.msg
                })
                // this.$message.error(response.msg)
              }
            })
          } else {
            Toast({
              duration: 2000,
              message: '手机号格式不对'
              //  手机号格式不对
            })
          }
        } else {
          Toast({
            duration: 2000,
            message: '请输入手机号'
          //  手机号不可为空
          })
        }
      },
      getInfo () {
        let params = {
          userID: this.userID,
          openID: this.openID,
          type: this.type
        }
        this.$http.getInfo(params).then(response => {
          if (response.state === 1) {
            this.$store.commit("setUserInfo", {})
            this.$store.commit("setUserInfo", response.data)
            if (this.type === 1) {
              this.$router.push({path: '/my-information'})
            } else if (this.type === 2) {
              this.$router.push({path: '/house-property'})
            } else if (this.type === 3) {
              this.$router.push({path: '/my-Charge'})
            } else if (this.type === 4) {
              this.$router.push({path: '/heating-charge'})
            } else {
              this.$router.go(-1)
            }
          }
        })
      },
      submitForm(phoneForm){
        this.$refs[phoneForm].validate((valid) => {
          if (valid) {
            let params = {
              userID: this.userID,
              openID: this.openID,
              name: this.phoneForm.name,
              phone: this.phoneForm.number,
              code: this.phoneForm.yzmnum
            }
            this.$http.register(params).then(response => {
              if (response.state === 1) {
                Toast({
                  duration: 2000,
                  message: '绑定成功'
                })
                this.getInfo()
              } else {
                Toast({
                  duration: 2000,
                  message: response.msg
                })
              }
            })
          }
        })
      },
      history () {
        this.phoneForm.name = ""
        this.phoneForm.number = this.$store.getters.getPhoneInfo.phone
        this.phoneForm.yzmnum = this.$store.getters.getPhoneInfo.yzm
      }
    },
    beforeRouteLeave(to, from, next) {
      let toName = to.name
      if (toName === "check") {
        localStorage.clear()
        window.WeixinJSBridge.call('closeWindow')
      } else {
        next()
      }
    },
    mounted () {
      this.history()
    }
  }
</script>

<style scoped>
  .demo-ruleForm {
    position: relative;
    top: 15%;
  }

  .hang {
    margin-left: -5%;
  }

  .div1 {
    float: left;
    margin-top: 5px;
    position: relative;
    left: 64%;
    height: 30px;
    width: 80px;
    text-align: center;
    background-color: gainsboro;
    border-radius: 10px;
  }

  .yzm {
    float: left;
    position: relative;
    left: 10%;
    top: -13%;
  }

  .update-phone >>> .el-dialog {
    border: 0px;
    border-style: solid;
    border-radius: 2%;
    position: absolute;
    top: -5%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 90%;
    height: 80%;
  }
  .update-phone >>>.el-dialog__body {
    padding: 0px;
    line-height: 40px;
    overflow-y: scroll;
    height: 85%;
    padding: 5%;
  }
  .update-phone >>> .el-dialog__header {
    height: 20px;
    text-align: center;
  }
  .update-phone >>>  .el-dialog__title {
    position: relative;
    top: -5px;
    font-size: 15px;
  }
  .update-phone >>> .el-form-item__error {
    margin-left: -22%;
  }
</style>
<style>
  .el-message-box {
    width: 80%;
    margin-top: -10%;
  }

  .el-input.is-disabled .el-input__inner {
    /*color: #333333;*/
    color: #666666;
    -webkit-text-fill-color: #666666;
    -webkit-opacity: 1;
    opacity: 1;
  }

  .el-checkbox {
    line-height: 0px;
    margin-right: 30px;
  }

  .nut-checkbox {
    margin: 0px;
  }

  .nut-checkbox input:checked {
    box-shadow: 0px 0px;
    background-color: #409eff;
    border-color: #409eff;
  }
  .el-button--success.is-disabled, .el-button--success.is-disabled:active, .el-button--success.is-disabled:focus, .el-button--success.is-disabled:hover {
    color: #FFF;
    background-color: #E0F3D8;
    border-color: #E0F3D8;
  }
  .el-input--small .el-input__inner{
    line-height:0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/updatePhone.vue